module.exports = __webpack_public_path__ + "img/whatsapp-stuffed.3c8ac3fb.svg";